import { get, writable } from "svelte/store";
import { defaultSelectedUser, isDashboardAdmin, users } from "./usersAndGroups";
import { getFromLocalStorage } from "./utils.js";

export const todoActivityOptions = [
  {
    value: "linkedinConnectionRequest",
    label: "Connection Requests",
    icon: "liConnectionRequests",
    allUsers: true,
  },
  { value: "phoneCall", label: "Calls", icon: "calls", allUsers: true },
  {
    value: "sendInmail",
    label: "InMails",
    icon: "liInMails",
    allUsers: true,
  },
  {
    value: "generalTask",
    label: "General Task",
    icon: "generalTasks",
    allUsers: true,
  },
  {
    value: "sendEmailAfterInmail",
    label: "Approve Emails",
    icon: "approveEmails",
  },
  {
    value: "sms",
    label: "Approve SMS",
    icon: "sms",
  },
];

const defaultToDosUser = () => {
  // NOTE
  // there exists edge case where team has no users (e.g. just viewer(s))
  // in this case defaultToDosUser() will return undefined (users[0])
  if (get(isDashboardAdmin)) {
    const storedUser = getFromLocalStorage("selectedToDosUser");
    if (storedUser) {
      if (users.find((user) => user.value === storedUser.value))
        return storedUser;
    }
  }
  return defaultSelectedUser || users[0];
};

export const selectedToDosUser = writable(defaultToDosUser());
